// extracted by mini-css-extract-plugin
export default {"container":"filter-module___container___b2daf50d","removeButton":"filter-module___removeButton___a48f8130"};